export default __webpack_public_path__ + "static/media/Logo_Blue_VEA.888c7bff.svg";